<script lang="ts">
const styles = _stylex_create({
  header: {
    paddingBlock: '1rem',
    paddingInline: '1.5rem',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '1rem',
    marginInlineStart: 'auto',
  },
})
</script>
<script setup lang="ts">
import __MACROS__stylex_attrs from "/vue-macros/define-stylex/stylex-attrs";
import { create as _stylex_create, props as _stylex_props } from '@stylexjs/stylex'
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import UserInfo from './UserInfo'

const route = useRoute()

const showHome = computed(() => route.name !== 'home')
const showAdmin = computed(() => route.name === 'home')


</script>

<template>
  <header v-bind="__MACROS__stylex_attrs(_stylex_props(styles.header))">
    <nav v-bind="__MACROS__stylex_attrs(_stylex_props(styles.nav))" aria-label="Primary navigation">
      <RouterLink v-if="showHome" to="/">
        Home
      </RouterLink>

      <div v-bind="__MACROS__stylex_attrs(_stylex_props(styles.actions))">
        <RouterLink v-if="showAdmin" :to="{ name: 'admin', params: { page: 1 } }">
          Admin
        </RouterLink>
        <UserInfo />
      </div>
    </nav>
  </header>
</template>
